import * as React from 'react';
import { getBackgroundColorClass, } from '@telia-front/colors';
const TableCell = (props) => {
    const { type = 'td', width, padding, indentLevel, valign, background, className, id, colSpan, rowSpan, headless, scope, children, } = props;
    const Element = type;
    const BEM = () => {
        const classArray = ['table__cell'];
        if (width) {
            classArray.push(`table__cell--${width}`);
        }
        if (padding) {
            classArray.push(`table__cell--padding-${padding}`);
        }
        if (indentLevel) {
            classArray.push(`table__cell--indent-level-${indentLevel}`);
        }
        if (valign) {
            classArray.push(`table__cell--valign-${valign}`);
        }
        if (background && background !== 'transparent') {
            classArray.push(getBackgroundColorClass(background));
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(Element, { className: BEM(), id: id, colSpan: colSpan, rowSpan: rowSpan, "data-headless": headless, scope: type === 'th' ? scope : undefined }, children));
};
export { TableCell as default, };
